import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { Loading } from '../../components/Loading';
import { growlErrors } from '../../utils/NotificationUtil';
import UserDetail from './UserDetail';
import { NotificationContext } from '../../components/GrowlNotifications';

const USER_QUERY = gql`
  query getUserById($accountId: ID!, $id: ID!, $first: Int) {
    account(id: $accountId) {
      id
      companyInformation {
        name
      }
      user(id: $id) {
        id,
        firstName,
        lastName,
        email,
        country,
        createdOn,
        locale,
        timeZone,
        enabled,
        emailVerified,
        availableMultiFactorAuthenticationOptions,
        currentMultiFactorAuthenticationOption,
        roles {
            account {
                id
            },
            role {
              id
              name
              displayName
              description
            }
        },
        accounts(first: $first) {
          edges {
            node {
              id
            }
            agreedToBeContactedByGpi,
            gpiContactAgreementUpdatedOn
            agreedToBeContactedByGpiReseller
            gpiResellerContactAgreementUpdatedOn
            agreedToBeContactedByGpiPartners
            gpiPartnersContactAgreementUpdatedOn
          }
        }
      }
    }
  }
`;

const UserDetailComponent = ({ viewerId, viewerRole, userId, accountId }) => {
  const growl = useContext(NotificationContext);

  const variables = {
    accountId,
    id: userId,
    first: 100,
  };

  return (
    <Query query={USER_QUERY} variables={variables}>
      {({ loading, error, data }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
        }

        const { user, companyInformation: { name: accountLegalName } } = data.account;

        return (
          <UserDetail
            viewerId={viewerId}
            viewerRole={viewerRole}
            user={user}
            accountLegalName={accountLegalName}
            accountId={accountId}
          />
        );
      }}
    </Query>
  );
}

UserDetailComponent.propTypes = {
  userId: PropTypes.string.isRequired,
  viewerId: PropTypes.string.isRequired,
  viewerRole: PropTypes.string.isRequired,
};

export default UserDetailComponent;
